var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header-index-wide"},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{staticClass:"keep-alive"})],1):_c('route-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }